import vmClient from 'app/services/vmClient';
import { IImage, Image } from 'app/constants/schemas/Image';
import { ISound, Sound } from 'app/constants/schemas/Sound';
import { IText, Text } from 'app/constants/schemas/Text';
import { Entity, IEntityType, IEntity } from 'app/types/entity';

export interface IMediaEntry extends IEntity {
  associations: {
    image: IImage | null;
    sound: ISound | null;
    captionText: IText | null;
  };
}

export type MediaEntry = Entity<IMediaEntry>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaEntry: IEntityType<IMediaEntry> = vmClient.defineClass({
  typeName: 'MediaEntry',
  version: 1,
  persisted: true,
  associations: {
    image: Image,
    sound: Sound,
    captionText: Text,
  },
});
